<template>
  <div class="story-details-page banner">
    <div>
      <div v-if="story && story.id">
        <div class="story-content">
          <div class="nav-indicator py-5">
            <NavIndicator :navIndicator="navIndicator" />
          </div>
          <div class="story-hero">
            <img
              :src="story.image"
              class="story-image"
              :alt="story.name"
            ></img>
            <div class="story-quote">
              <v-icon class="quote-icon">mdi-format-quote-open</v-icon>
              <p class="quote-text">{{ story.quote }}</p>
              <p class="author">{{ story.name }}</p>
              <p class="role">{{ story.role }}</p>
            </div>
          </div>
          <div class="story-body">
            <div class="story-video">
              <YouTubePlayer :video-link="story.videoUrl" height="auto" max-width="750px"/>
            </div>
            <div class="body-description">
              <div v-for="(section, index) in story.body" :key="index">
                <h2 v-if="section.title">{{ section.title }}</h2>
                <p class="story-description" v-html="section.description"></p>
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="more-story">
          <h2 class="section-title">
            More <span class="underline">Stories</span>
          </h2>
          <div class="more-story-container">
            <MoreStories
              :current-story-id="story.id?.toString()"
              :stories="storiesData"
              :showTitle="false"
              :aspect-ratio="1"
              :justifyContent="justifyContent"
            />
          </div>
        </div> -->
      </div>
      <div v-else class="text-center">
        <h2>Story Not Found</h2>
        <p>The story you are looking for does not exist.</p>
        <router-link to="/impact-stories">View All Stories</router-link>
      </div>
    </div>
  </div>
  <GetInTouch :backgroundColor="'#DEF3FF'" />
</template>

<script setup>
import { ref, computed } from 'vue';
import { useRoute } from 'vue-router';
import NavIndicator from '@/components/partials/NavIndicator.vue';
import GetInTouch from './../../service/components/GetInTouch.vue';
import YouTubePlayer from './../../resources/learningHub/YoutubePlayer.vue';
import MoreStories from './../../customers/StoryPages/Components/MoreStories.vue';
import { storiesData } from './../StoriesData';

const route = useRoute();
const justifyContent = 'center';
const story = computed(() => {
  return storiesData.find((s) => s.slug === route.params.slug) || {};
});

const navIndicator = computed(() => [
  { text: 'Home', icon: 'fas fa-home', link: '/' },
  { text: 'Impact Stories', link: '/impact-stories' },
  { text: story.value.name || 'Story', link: '' },
]);

document.getElementById('loaderSection').classList.add('d-none');
</script>

<style scoped>
.story-details-page {
  background-color: white;
  
}

.story-content {
  max-width: 1200px;
  margin: 0 auto;
  /* padding: 4rem 2rem; */
}

.nav-indicator {
  padding-bottom: 4rem;
}

.story-hero {
  position: relative;
  background-color: #def5ff;
  border-radius: 10px;
  padding: 20px;
  margin-bottom: calc(
    6rem + 20px
  ); /* Space for bottom overflow + some margin */
  margin-top: calc(1rem + 20px); /* Space for top overflow + some margin */
  overflow: visible !important;
  min-height: 220px;
  text-align: left;
  display: flex;
  align-items: center;
  max-height: 240px;
}

.story-image {
  position: absolute;
  height: 270px;
  border-radius: 10px !important;
  z-index: 2 !important;
  object-fit: cover !important;
  /* box-shadow: 0px 0px 0px 1px rgba(0, 0, 0, 0.15); */
  aspect-ratio: 1;
}

.story-quote {
  flex: 1;
  margin-left: 310px; /* Increased margin to accommodate image */
  margin-right: 2rem;
  position: absolute;
  padding: 20px 0;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 160px;
}

.quote-icon {
  font-size: 3rem;
  color: var(--secondary-color-lighten-2);
}
.quote-text {
  font-style: italic;
  color: #666;
  margin-bottom: 10px;
  font-size: 1.1em;
  line-height: 1.4;
}

.author {
  font-weight: bold;
  color: #333;
  margin-bottom: 5px;
  margin-top: 1rem;
  font-size: 1.1em;
}

.role {
  color: #666;
  font-size: 0.9em;
}

.story-body {
  display: flex;
  flex-direction: column;
  align-items: center;
}

h2 {
  font-size: 2em;
  color: #333;
  margin-bottom: 20px;
}

.body-description {
  max-width: 760px;
  width: 100%;
  text-align: left;
  margin: 3rem auto;
}

.story-description {
  font-size: 1em;
  color: #666;
  line-height: 1.6;
  margin-bottom: 20px;
}

.underline {
  position: relative;
  display: inline-block;
  color: #ff6860;
}

.section-title {
  font-size: 35px;
  font-weight: 700;
  padding-bottom: 2rem;
  position: relative;
  display: inline-block;
}

.more-story {
  background-color: #f7f8fc;
  width: 100%;
  padding: 6rem 0 2rem 0;
  display: flex;
  flex-direction: column;
  /* justify-content: right; */
}
.more-story-container{
  /* width: 100%; */
  /* max-width: 1000px; */

}
.story-video {
  position: relative;
  width: 100%;
  max-width: 1100px;
}

/* Tablet responsiveness */
@media only screen and (max-width: 768px) {
  .story-hero {
    flex-direction: column;
    text-align: center;
    min-height: 350px;
  }

  .story-image {
    width: 190px !important;
    height: 190px !important;
    top: -80px !important;
    bottom: auto !important;
    left: 50% !important;
    transform: translateX(-50%) !important;
    position: absolute !important;
  }

  .story-quote {
    margin-left: 0;
    margin-top: 2rem;

    padding: 20px;
    width: 100%;
  }

  .quote-text {
    font-size: 1em;
  }

  .author {
    margin-top: 1rem;
    font-size: 1em;
  }
  .more-story {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    align-content: center;
  }
}

/* Mobile responsiveness */
@media only screen and (max-width: 480px) {
  .story-content {
    padding: 20px 15px;
  }

  .story-hero {
    margin-top: 3rem;
    margin-bottom: calc(60px + 1rem);
    min-height: 340px;
  }

  .story-image {
    width: 160px !important;
    height: 160px !important;
    top: -70px !important;
  }

  .story-quote {
    padding: 15px;
  }

  .quote-text {
    font-size: 0.95em;
    line-height: 1.3;
  }

  .author {
    font-size: 0.95em;
  }

  .role {
    font-size: 0.85em;
  }
}

/* Extra small mobile */
@media only screen and (max-width: 360px) {
  .story-image {
    width: 140px !important;
    height: 140px !important;
    top: -60px !important;
  }

  .story-quote {
    padding: 10px;
  }

  .quote-text {
    font-size: 0.9em;
  }

  .section-title {
    font-size: 28px;
  }
}
@media only screen and (max-width: 1280px){
  .banner {
    padding: 0 5rem;
  }
}
@media only screen and (max-width: 1050px){
  .banner {
    padding: 0 4rem;
  }
}
@media only screen and (max-width: 840px){
  .banner {
    padding: 0 3rem;
  }
}
@media only screen and (max-width: 640px){
  .banner {
    padding: 0 2rem;
  }
}
@media only screen and (max-width: 470px){
  .banner {
    padding: 0 1rem;
  }
}
</style>
